import { LOGIN, LOGOUT } from './auth.types';

export const authLogin = (payload) => ({
  type: LOGIN,
  payload,
});
export const authLogout = () => ({
  type: LOGOUT,
});
